<!-- <head><meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"></head> -->
<div *ngIf="isOrderCancel">
<div class="modal-header customBlueHeader">
  <p class="modal-title">Order Cancel</p>
  <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
  </button> -->

  <button type="button" class="close" aria-label="Close" (click)="modelClose()">
    <span aria-hidden="true">&times;</span>
</button>
</div>
<div class="modal-body customModalBody">
    
    <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
    <form [formGroup]="orderCancelForm" (ngSubmit)="orderCancel(orderCancelForm)">


        <div class="form-group">
            <label>Select Reason Type</label>
            <select class="form-control col-form-label-sm" formControlName="reasonType"  (change)="getSubType($event.target.value)">
              <!-- <option>Select</option> -->
              <option [ngValue]="null" disabled>Select</option>
              <option  *ngFor="let orderCancelType of orderCancelTypes" value={{orderCancelType.Id}}>
                {{orderCancelType.name}} 
      
              </option>
            </select>
          </div>

           <div class="form-group">
            <label>Select Sub Reason Type</label>
            <select class="form-control col-form-label-sm" formControlName="subReasonType">
              <option>Select</option>
              <option  *ngFor="let orderCancelSubType of orderCancelSubTypes" value={{orderCancelSubType.Id}}>
                {{orderCancelSubType.name}} 
      
              </option>
            </select>
          </div> 

          <div class="form-group">
            <label>Reason</label>
            <textarea class="form-control col-form-label-sm" formControlName="reason"></textarea>
          </div>
          <div class="modal-footer customModalFooter customModalFooter">
            <button type="button" class="btn closeGreenBordBtn" (click)="close()">Close</button>
            <button type="submit" class="btn green_btn" [disabled]="!isButtonEnable">Order Cancel</button>
          </div>
         
        </form>


</div>

</div>

<div *ngIf="isEscalationOrderCancel">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Order Cancel</p>
 
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
  </button>
  </div>
  <div class="modal-body customModalBody">
   
      <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
      <form [formGroup]="orderCancelForm" (ngSubmit)="orderCancel(orderCancelForm)">
            <div class="form-group">
              <label>Reason</label>
              <textarea class="form-control col-form-label-sm" formControlName="reason" placeholder="Cancellation Reason"></textarea>
            </div>
            <div class="form-group">
              <label>Total Amount</label>
              <input type="text" class="form-control col-form-label-sm" formControlName="totalAmount" disabled>
            </div>

                <div class="form-group">
                  <label>Percentage %</label>
                  <select class="form-control col-form-label-sm" formControlName="percentage">
                    <option value="null" [disable]>Select</option>
                    <option value="0">0% - 0.00</option>
                    <option value="20">20% - {{per20}}</option>
                    <option value="40">40% - {{per40}}</option>
                    <option value="60">60% - {{per60}}</option>
                    <option value="80">80% - {{per80}}</option>
                    <option value="100">100% - {{per100}}</option>
                  </select>
                </div>  
 
            <div class="modal-footer customModalFooter customModalFooter">
              <button type="button" class="btn closeGreenBordBtn" (click)="close()">Close</button>
              <button type="submit" class="btn green_btn" [disabled]="!isButtonEnable">Order Cancel</button>
            </div>
           
          </form>
 
 
  </div>
 
  </div>